/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner } from '../models/OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner';
import { OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner } from '../models/OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner';

export class OnboardAzureSourceAccountInteractiveRequest {
  /**
  * Azure tenant ID
  */
  'tenantId': string;
  /**
  * List of subscriptions to onboard
  */
  'subscriptions'?: Array<OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner>;
  /**
  * List of management groups to onboard
  */
  'managementGroups'?: Array<OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner>;
  /**
  * Azure region for resource creation
  */
  'location'?: string;
  /**
  * Resource tags to apply
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptions",
      "baseName": "subscriptions",
      "type": "Array<OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner>",
      "format": ""
    },
    {
      "name": "managementGroups",
      "baseName": "managementGroups",
      "type": "Array<OnboardAzureSourceAccountInteractiveRequestManagementGroupsInner>",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return OnboardAzureSourceAccountInteractiveRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

